import { useSelector } from "react-redux";
import { selectRestaurantsOfferState } from "../../store/restaurantsStore/offerSelectors";
import { getSortedRestaurantsSelector } from "../../store/restaurantsStore/selectors";
import { ON_OFFER } from "../../types/offerStates";

export const useRestaurants = () => {
  const restaurants = useSelector(getSortedRestaurantsSelector);
  const oferState = useSelector(selectRestaurantsOfferState);
  const restaurantsNotOnOffer = restaurants.filter(
    r => oferState[r._id] !== ON_OFFER
  );
  const restaurantsOnOffer = restaurants.filter(
    r => oferState[r._id] === ON_OFFER
  );
  return [restaurantsOnOffer, restaurantsNotOnOffer];
};
